import { Tooltip as MortarTooltip } from '@policygenius/mortar';
import React, { MouseEvent } from 'react';

import { frontendAnalyticsTrack } from 'analytics/utils';

import { CLICKED_TOOLTIP_EVENT, HOVER_TOOLTIP_EVENT } from './constants';
import { IProps } from './types';

const Tooltip: React.FC<IProps> = ({ analyticsProperties, onClick, ...props }) => {
  const handleClick = (event: MouseEvent<HTMLSpanElement>, visible: boolean) => {
    frontendAnalyticsTrack(CLICKED_TOOLTIP_EVENT, { ...analyticsProperties });

    return onClick && onClick(event, visible);
  };

  const handleHover = () => {
    const analyticsProps = {
      text: analyticsProperties?.text || 'help icon',
      ...analyticsProperties,
    };

    return frontendAnalyticsTrack(HOVER_TOOLTIP_EVENT, analyticsProps);
  };

  return (
    <span onMouseEnter={handleHover}>
      <MortarTooltip {...props} onClick={handleClick} />
    </span>
  );
};

export default Tooltip;
